export default "__VITE_ASSET__00GojPQA__"